export const ACTIVE_CLOSED_TAB = 'activeClosed'
export const CLOSED_REPORTING_TAB = 'closedReporting'
export const COUNTRIES_LAST_UPDATE_TAB = 'countriesLastUpdate'
export const DELAYED_RTLOG_TAB = 'delayedRtlog'
export const DELAYED_STORES_TAB = 'delayedStores'
export const ZERO_REPORTING_TAB = 'zeroReporting'

export const constants = 'closedReporting'

export const COUNTRIES_LIST_TYPES = {
  LATEST_REPORTS: 'LATEST_REPORTS',
  NO_REPORTS: 'NO_REPORTS',
}

export const FETCH_CLOSED_REPORTING_ONLY_STORES = 'FETCH_CLOSED_REPORTING_ONLY_STORES'
export const FETCH_CLOSED_REPORTING_ONLY_STORES_ERROR = 'FETCH_CLOSED_REPORTING_ONLY_STORES_ERROR'
export const FETCH_CLOSED_REPORTING_ONLY_STORES_SUCCESS = 'FETCH_CLOSED_REPORTING_ONLY_STORES_SUCCESS'

export const HIDE_DETAILS = 'HIDE_DETAILS'
export const OPEN_DETAILS = 'OPEN_DETAILS'

export const CLOSE_CHANNEL_DETAILS = 'CLOSE_CHANNEL_DETAILS'
export const SHOW_CHANNEL_DETAILS = 'SHOW_CHANNEL_DETAILS'

export const SET_SELECTED_VALUE = 'SET_SELECTED_VALUE'
